import { TranslateService } from '@ngx-translate/core';
import { fieldNames } from 'app/Model/FieldNames';
import { Item as dxListItem } from 'devextreme/ui/list';
import { LoginService } from './login.service';
import { Injectable } from '@angular/core';
import { FieldType } from 'app/Model/Catalog/TemplateItem';
import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { CatalogService } from './CatalogManagement/catalog.service';
import { TemplateItemTemplate } from 'app/Model/Catalog/TemplateItemTemplate';
import { lastValueFrom } from 'rxjs';
import { forEach } from 'jszip';



@Injectable({ providedIn: 'root' })
export class TemplateFieldsService {
  productFields: TemplateItemTemplate[] = [];
  mimeFields: TemplateItemTemplate[] = [];
  featureFields: TemplateItemTemplate[] = [];
  orderDetailFields: TemplateItemTemplate[] = [];
  pricelistFields: TemplateItemTemplate[] = [];
  logisticsFields: TemplateItemTemplate[] = [];
  referenceFields: TemplateItemTemplate[] = [];
  udxFields: TemplateItemTemplate[] = [];
  seoFields: TemplateItemTemplate[] = [];
  legalFields: TemplateItemTemplate[] = [];
  miscFields: TemplateItemTemplate[] = [];
  supplierFields: TemplateItemTemplate[] = [];
  packingFields: TemplateItemTemplate[] = [];
  categoryFields: TemplateItemTemplate[] = [];
  shopware6Fields: TemplateItemTemplate[] = [];
  wawiFields: TemplateItemTemplate[] = [];
  kiPromptFields: TemplateItemTemplate[] = [];
  sellsiteFields: TemplateItemTemplate[] = [];
  private allFields: TemplateItemTemplate[] = [];

  constructor(private loginService: LoginService, private catalogService: CatalogService, private translate: TranslateService) {

  }

  async loadFields() {
    await lastValueFrom<TemplateItemTemplate[]>(this.catalogService.loadFields2Subscribe());
    this.allFields = this.catalogService.fields;
    this.productFields = this.createFieldList('Basic');

 
   
    this.mimeFields = this.createFieldList('Mimes');;
    this.featureFields = this.createFieldList('Features');
    this.orderDetailFields = this.createFieldList('OrderDetails');
    this.pricelistFields = this.createFieldList('Price');
    this.logisticsFields = this.createFieldList('Logistic');
    this.referenceFields = this.createFieldList('References');
    this.udxFields = this.createFieldList('Udx');
    this.seoFields = this.createFieldList('Seo');
    this.legalFields = this.createFieldList('Legal');
    this.miscFields = this.createFieldList('Misc');
    this.supplierFields = this.createFieldList('Suppliers');
    this.packingFields = this.createFieldList('Packing');
    this.categoryFields = this.createFieldList('Category');
    this.shopware6Fields = this.createFieldList('Shopware6');
    this.wawiFields = this.createFieldList('Wawi/ERP');
    this.kiPromptFields = this.createFieldList("Kiprompts");
    this.sellsiteFields = this.createFieldList("Sellsite_neu");
  }

  getFieldType(pimField: NextPimField): FieldType {
    let field = pimField.field;
    if (!field) return 'fixed';
    field = field.split('__')?.[0];

    if (this.featureFields.some((x) => x.field === field)) {
      return 'feature';
    } else if (this.mimeFields.some((x) => x.field === field)) {
      return 'mime';
    } else if (this.pricelistFields.some((x) => x.field === field)) {
      return 'price';
    } else if (this.legalFields.some((x) => x.field === field)) {
      return 'legal';
    } else if (this.miscFields.some((x) => x.field === field)) {
      return 'misc';
    } else if (this.referenceFields.some((x) => x.field === field)) {
      return 'reference';
    } else if (this.seoFields.some((x) => x.field === field)) {
      return 'seo';
    } else if (this.supplierFields.some((x) => x.field === field)) {
      return 'supplier';
    } else if (this.udxFields.some((x) => x.field === field)) {
      return 'udx';
    } else if (this.orderDetailFields.some((x) => x.field === field)) {
      return 'orderdetail';
    } else if (this.productFields.some((x) => x.field === field)) {
      return 'standard';
    } else if (this.packingFields.some((x) => x.field === field)) {
      return 'packing';
    } else if (this.logisticsFields.some((x) => x.field === field)) {
      return 'logistics';
    } else if (this.categoryFields.some((x) => x.field === field)) {
      return 'category';
    } else if (this.shopware6Fields.some((x) => x.field === field)) {
      return 'shopware6';
    } else if (this.wawiFields.some((x) => x.field === field)) {
      return 'wawi';
    } else if (this.kiPromptFields.some((x) => x.field === field)) {
      return 'kiprompt';
    } else if (this.sellsiteFields.some((x) => x.field === field)) {
      return 'sellsite_neu';
    }

    return 'fixed';
  }

  numberToExcelColumn(num: number) {
    let columnName = '';

    while (num > 0) {
      num--; // Reduzieren um 1, da Excel bei 1 startet, nicht bei 0
      let remainder = num % 26;
      columnName = String.fromCharCode(65 + remainder) + columnName;
      num = Math.floor(num / 26);
    }

    return columnName;
  }

  excelColumnToNumber(column: string) {
    column = column.toUpperCase();
    let result = 0;
    for (let i = 0; i < column.length; i++) {
      result *= 26;
      result += column.charCodeAt(i) - 64;
    }
    return result;
  }

  private createFieldList(groupName :string ): TemplateItemTemplate[] {
    const fields = this.allFields.filter((x) => x.group === groupName && !x.notForExpertTemplate);
    fields.forEach(f => {
      f.text = this.translate.instant(f.field);
    })
    return fields;
    
  }

}
